export default __webpack_public_path__ + "static/media/pop-it-text.e11e6ea1.svg";